var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[(_vm.cfg && _vm.cfg.list)?_vm._l((_vm.cfg.list),function(l,idx){return _c('li',{key:idx},[_c('b',[_vm._v(_vm._s(idx + 1))]),_c('span',{domProps:{"innerHTML":_vm._s(l)}})])}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }